/** @format */

import React, { Component } from "react";
import {
	Row,
	Col,
	Form,
	FormGroup,
	Label,
	Input,
	Button,
	CustomInput,
	Collapse,
	Card,
	CardHeader,
	CardBody,
	Container,
	Breadcrumb,
	BreadcrumbItem,
	CardText,
} from "reactstrap";
import Header from "../components/Header";
import Icon from "../components/Icon";
import Footer from "../components/Footer";
import CheckoutSummary from "../components/CheckoutSummary";
import { addressUrl } from "../global/url";
import { checkoutUrl } from "../global/url";
import { showNotification } from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";

import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
	getUrlParam,
} from "../global/browserFunctions";

class Checkout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			addressArr: [],
			addressId: "",
			summary: {},
			shipping_method: {
				shipping_method: { itemid: { value: "Loading" } },
				shipping_cost: "0.00",
			},
		};

		this.placeOrder = this.placeOrder.bind(this);
		document.title = "Checkout";

		if (!getCookie("log")) {
			this.GoToPage("/");
		}

		this.onRadioChange = this.onRadioChange.bind(this);
	}

	componentDidMount() {
		this.setState({ loading: true });
		this.fetchAddress();
		this.fetchSummary();
	}

	placeOrder() {
		this.setState({ loading: true });
		var query = "&apiType=checkoutCart&customerId=";
		var customer = getCookie("customid");
		query += customer;
		query +=
			"&shipaddressId=" +
			this.state.addressId +
			"&billaddressId=" +
			this.state.addressId;

			var self = this;
			jquery
				.ajax({
					url: checkoutUrl + query,
					Cache: false,
					dataType: "jsonp",
				})
				.done(function (data) {
					self.setState({ loading: false });
					try {
						console.log('data',data)
						data = JSON.parse(decodeURIComponent(data));
						if (data.summary.status == "SUCCESS") {
							var route="/checkout-confirm?id=";
							var id=data.data.order_summary && data.data.order_summary.tranid.value;
							var amt=data.data.order_summary && data.data.order_summary.total_fx.value;

							route+=id;
							route+="&amt="+amt;
							self.GoToPage(route);
						} else {
							showNotification(
								"Sorry",
								"danger",
								"An unknown error occurred. we couldn't process your order. go back to cart page and try again"
							);
						}
					} catch (error) {
						console.log("error@summary", error);
						showNotification(
							"Sorry",
							"danger",
							"An unknown error occurred."
						);
					}
				})
				.fail(function () {
					self.setState({ loading: false });
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Check your conection"
					);
				});
	}

	fetchSummary() {
		var query = "&apiType=checkoutInformation&customerId=";
		var customer = getCookie("customid");
		query += customer;
		//this.setState({loading: true})
		var self = this;
		jquery
			.ajax({
				url: checkoutUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				self.setState({ loading: false });
				try {
					data = JSON.parse(decodeURIComponent(data));
					if (data.summary.status == "SUCCESS") {
						var summary = data.data.order_summary || {};
						var shippingInfo = data.data.shippingcost_summary || {
							shipping_method: { itemid: { value: "Loading" } },
							shipping_cost: "0.00",
						};
						console.log("shippingInfo", shippingInfo);
						self.setState({ summary: summary });
						self.setState({ shipping_method: shippingInfo });
					} else {
						showNotification(
							"Sorry",
							"danger",
							"An unknown error occurred. Couldn't fetch order summary"
						);
					}
				} catch (error) {
					console.log("error@summary", error);
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Couldn't fetch order summary"
					);
				}
			})
			.fail(function () {
				self.setState({ loading: false });
				showNotification(
					"Sorry",
					"danger",
					"An unknown error occurred. Couldn't fetch order summary"
				);
			});
	}

	fetchAddress() {
		//this.setState({loading: true})
		var query = "&method=view&customer=";
		var customer = getCookie("customid");
		query += customer;
		var self = this;
		jquery
			.ajax({
				url: addressUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				//self.setState({ loading: false });
				try {
					data = JSON.parse(data);
					if (data[0].responseString == "SUCCESS") {
						var address = JSON.parse(
							decodeURIComponent(data[0].responseMessage)
						);
						for (var i in address) {
							if (address[i].isdefaultshipping.value) {
								address[i].checked = true;
								self.setState({addressId: address[i].addressinternalid.value})
							}
						}
						self.setState({ addressArr: address });
						setLocalStorage("Address", JSON.stringify(address));
					} else {
						showNotification(
							"Sorry",
							"danger",
							"An unknown error occurred. Couldn't fetch your addresses"
						);
					}
				} catch (error) {
					console.log("error@address", error);
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Couldn't fetch your addresses"
					);
				}
			})
			.fail(function () {
				//self.setState({ loading: false });
				showNotification(
					"Sorry",
					"danger",
					"An unknown error occurred. Couldn't fetch your addresses"
				);
			});
	}

	GoToPage(path) {
		this.props.history.push(path);
	}
	onRadioChange(e, eachAddress) {
		console.log("eachAddress", eachAddress);
		var address = [...this.state.addressArr];
		var index = address.findIndex(
			(x) => x.addressinternalid.value == eachAddress.addressinternalid.value
		);
		for (var i in address) {
			address[i].checked = false;
		}

		address[index].checked = true;
		this.setState({ addressId: address[index].addressinternalid.value });
		this.setState({ addressArr: address });
	}
	render() {
		return (
			<React.Fragment>
				<Loader loading={this.state.loading} />
				<Header headermenu={this.headermenu} history={this.props.history} />
				<section className='hero py-6'>
					<Container>
						<Breadcrumb className='pl-0'>
							<BreadcrumbItem>
								<a href='/home'>Home</a>
							</BreadcrumbItem>
							<BreadcrumbItem active>Checkout</BreadcrumbItem>
						</Breadcrumb>
						<div className='hero-content'>
							<h1 className='hero-heading'>Checkout</h1>
						</div>
					</Container>
				</section>
				<section className='pb-6'>
					<Container>
						<Container>
							<Row>
								<Col lg='8'>
									<h5 className='mb-5'>Shipping Address</h5>
									<Row>
										{this.state.addressArr.map((eachAddress, index) => (
											<Col md='6' key={index}>
												<div className='card-radio mb-4'>
													<label
														className='card-label'
														htmlFor={eachAddress.addressinternalid.value}
													/>
													<input
														className='card-radio-input'
														type='radio'
														name={eachAddress.addressinternalid.value}
														id={eachAddress.addressinternalid.value}
														onChange={(e) => this.onRadioChange(e, eachAddress)} // On change func
														checked={eachAddress.checked}
													/>
													<Card>
														<CardHeader>
															<h6 className='mb-0'>Address {index + 1}</h6>
														</CardHeader>
														<CardBody>
															<div className='text-sm'>
																{eachAddress.addressee.value}
															</div>
															<div className='text-sm'>
																{eachAddress.address1.value}
															</div>
															<div className='text-sm'>
																{eachAddress.address2.value}
															</div>
															<div className='text-sm'>
																{eachAddress.city.value}
															</div>
															<div className='text-sm'>
																{eachAddress.state.value}{" "}
																{eachAddress.zipcode.value}
															</div>
															<div className='text-sm'>
																{eachAddress.country.text}
															</div>
															<div className='text-sm'>
																{eachAddress.addressphone.value}
															</div>
														</CardBody>
													</Card>
												</div>
											</Col>
										))}
										<Col md='6'>
											<a href='/edit-address'>
												<Card className='mb-5'>
													<CardBody className='py-4'>
														<CardText>
															<div className='text-center'>
																<Icon
																	icon='add-1'
																	className='w-3rem h-3rem mb-5 svg-icon-light text-dark'
																/>
																<h6 className='mb-0 text-dark text-center'>
																	Add New
																</h6>
															</div>
														</CardText>
													</CardBody>
												</Card>{" "}
											</a>
										</Col>
										<Col md='12'>
											<div className='card-radio mb-4'>
												<label className='card-label' />
												<input
													className='card-radio-input'
													type='radio'
													name='shipping'
													checked='true'
												/>
												<Card>
													<CardHeader>
														<h6 className='mb-0'>Delivery Method</h6>
													</CardHeader>
													<CardBody>
														<h6 className='mb-3'>
															${this.state.shipping_method.shipping_cost}
														</h6>
														<p className='text-muted text-sm card-text'>
															{
																this.state.shipping_method.shipping_method
																	.itemid.value
															}
														</p>

														<p className='text-muted text-sm card-text'>
															NOTE: Shipping charge may vary based on your order
														</p>
													</CardBody>
												</Card>
											</div>
										</Col>
										<Col md='12'>
											<div className='card-radio mb-4'>
												<label className='card-label' />
												<input
													className='card-radio-input'
													type='radio'
													name='payment'
													checked='true'
												/>
												<Card>
													<CardHeader>
														<h6 className='mb-0'>Payment Method</h6>
													</CardHeader>
													<CardBody>
														<h6 className='mb-3'>Invoice</h6>
														<p className='text-muted text-sm card-text'>
															We will send you the invoice details soon
														</p>
													</CardBody>
												</Card>
											</div>
										</Col>
										<Col md='12'>
											<div className='my-5 d-flex justify-content-between flex-column flex-lg-row'>
												<a href='/cart'>
													<Button
														color='link'
														className='text-muted'
														style={{ width: "100%" }}
													>
														<i className='fa fa-angle-left mr-2' />
														Back to the cart page
													</Button>
												</a>
												<a>
													<Button
														color='dark'
														style={{ width: "100%" }}
														onClick={(e) => this.placeOrder(e)}
													>
														Place an Order
														<i className='fa fa-angle-right ml-2' />
													</Button>
												</a>
											</div>
										</Col>
									</Row>
								</Col>
								<Col lg='4'>
									<CheckoutSummary summary={this.state.summary} />
								</Col>
							</Row>
						</Container>
					</Container>
				</section>
				<Footer />
			</React.Fragment>
		);
	}
}

export default Checkout;
